import { colsMedium, colsLarge } from "./WaypointsTableStyles";

export const WaypointsColumns = ({headerFontStyle, waypointFontStyle, summaryUnitLabels, size}) => {
    return [
    {
      name: (
        <div style={headerFontStyle}>Waypoint Name</div>
      ),
      selector: row => row.title,
      left: true,
      style: waypointFontStyle,
    },
    {
      name: (
        <div style={headerFontStyle}>Distance ({summaryUnitLabels[1]})</div>
      ),
      selector: row => row.distance_short,
      left: true,
    },
    {
      name: (
        <div style={headerFontStyle}>
          Elevation change ({summaryUnitLabels[2]})
        </div>
      ),
      selector: row => row.elevChange,
      left: true,
      omit: size.width < colsMedium,
    },
    {
      name: <div style={headerFontStyle}>Time</div>,
      selector: row => row.elapsedTime,
      left: true,
      maxWidth: '2rem',
      omit: size.width < colsMedium,
    },
    {
      name: <div style={headerFontStyle}>Pace ({summaryUnitLabels[0]})</div>,
      selector: row => row.pace,
      left: true,
      maxWidth: '2rem',
      omit: size.width < colsLarge,
    },
  ];
};